import styled from '@emotion/styled'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import CircleIcon from '@mui/icons-material/Circle'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import MuiAppBar from '@mui/material/AppBar'
import IconButton from '@mui/material/IconButton'
import { theme } from 'styles/theme/hav-theme'
import { css } from '@emotion/react'
import { Link } from 'react-router-dom'

export const WrapContainerStyled = styled('div')`
  height: 100%;
  background-color: ${theme.colors.support.red};
  max-width: unset;
`

export const AppBarStyled = styled(MuiAppBar)`
  ${({ height }: { height: number }) =>
    css`
      box-shadow: none;
      background: transparent;
      width: 100%;
      height: ${height}px;
    `}
`

export const WrapGridContainerStyled = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding-left: ${theme.spacing.lg};
  padding-right: ${theme.spacing.lg};

  @media only screen and (min-width: ${theme.breakpoints.lg}px) {
    padding-right: ${theme.spacing.xl};
    padding-left: ${theme.spacing.xl};
  }
`
interface NavItemStyledProps {
  active: string
  type?: string
}

export const TYPES_NAV_ITEM = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
}

export const NavItemStyled = styled(Link)<NavItemStyledProps>`
  display: flex;
  text-decoration: none;
  align-items: center;
  height: 40px;
  cursor: pointer;
  gap: ${theme.spacing.xs};
  font-family: ${theme.typography.family.primary};
  font-weight: ${({ active }) =>
    JSON.parse(active) ? theme.typography.weight.lg : theme.typography.weight.sm};
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.sm};
  color: ${({ type }) =>
    type === TYPES_NAV_ITEM.PRIMARY
      ? theme.colors.neutral.white
      : theme.colors.neutral.high};

  margin-left: ${theme.spacing.sm};
  margin-right: ${theme.spacing.sm};
  :hover {
    font-weight: ${theme.typography.weight.lg};
  }
`

export const DrawerNavItemStyled = styled(Link)<NavItemStyledProps>`
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: ${theme.spacing.xs};
  color: ${theme.colors.neutral.high};
  font-family: ${({ active }) =>
    JSON.parse(active) ? theme.typography.family.bold : theme.typography.family.primary};
  font-size: ${theme.typography.sizes.sm};
  line-height: ${theme.typography.lineHeight.md};
  padding: ${theme.spacing.xm} ${theme.spacing.lg};
`

export const ButtonsItemsStyled = styled('div')`
  display: grid;
  grid-auto-flow: column;
  column-gap: ${theme.spacing.xs};
  align-items: center;
`

export const CircleIconStyled = styled(CircleIcon)`
  font-size: ${theme.icon.size.x.small};
  margin: auto;
  margin-left: ${theme.spacing['2xl']};
  margin-right: ${theme.spacing['2xl']};
  fill: ${theme.colors.neutral.white};

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    margin-left: ${theme.spacing.sm};
    margin-right: ${theme.spacing.sm};
  }
`
export const RiceIcon = styled.div`
  display: flex;
  margin: 0 auto;
  min-height: 8px;
`

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ isNavItems }: { isNavItems?: boolean }) => css`
    ${isNavItems &&
    css`
      justify-content: flex-start;
      gap: ${theme.spacing.xs};
    `}
  `}
`

export const LogoHeader = styled('img')`
  margin: auto;
  height: 25px;
  margin-right: ${theme.spacing.xm};

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    margin: auto auto;
  }

  :hover {
    cursor: pointer;
  }
`

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  #number {
    font-size: ${theme.typography.sizes.md};
    font-weight: ${theme.typography.weight.md};
    line-height: 25px;
    @media only screen and (max-width: ${theme.breakpoints.lg}px) {
      font-size: ${theme.typography.sizes.sm};
    }
  }
  #business-hours {
    font-size: ${theme.typography.sizes['3xs']};
    font-weight: ${theme.typography.weight.sm};
    line-height: 15px;
  }
`
export const SideContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${theme.colors.quartenary};
  color: ${theme.colors.neutral.high};
  padding: ${theme.spacing.lg};
  #number {
    font-size: ${theme.typography.sizes.md};
    font-weight: ${theme.typography.weight.md};
    line-height: 25px;
  }
  #business-hours {
    font-size: ${theme.typography.sizes['3xs']};
    font-weight: ${theme.typography.weight.sm};
    line-height: 15px;
  }
`
export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`
export const ControlsWrapper = styled.div`
  ${({ height }: { height?: number }) => css`
    height: ${height ? height + 'px' : '30px'};
  `}
`

export const WrapSubContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const NotificationsButtonWrapper = styled.div`
  width: ${theme.spacing.xl};
  height: ${theme.spacing.xl};
`

export const NotificationNumberStyled = styled.div`
  background-color: ${theme.colors.neutral.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  top: -38px;
  left: 21px;
  font-size: ${theme.typography.sizes['2xs']};
  font-family: ${theme.typography.family.bold};
  color: ${theme.colors.support.red};
  border-radius: ${theme.shapes.borderRadius.full};
  border: 2px solid ${theme.colors.support.red};
  height: 20px;
  width: 20px;
`

export const IconButtonStyled = styled(IconButton)`
  color: inherit;
  display: flex;
  padding: 0;
  width: ${theme.spacing.xl};
  height: ${theme.spacing.xl};
  background-color: ${theme.colors.support.red};
  :hover {
    background-color: ${theme.colors.support.redhover};
  }
  border-radius: ${theme.shapes.borderRadius.sm};
`

export const MenuIconStyled = styled(MenuIcon)`
  font-size: ${theme.typography.sizes.xm};
  fill: ${theme.colors.neutral.white};
`

export const ChevronRightIconStyled = styled(ChevronRightIcon)`
  font-size: 20px;
  fill: ${theme.colors.primary.main};
`

export const ChevronLeftIconStyled = styled(ChevronLeft)`
  font-size: 20px;
  fill: ${theme.colors.primary.main};
`

export const ChevronDownIconStyled = styled(KeyboardArrowDownIcon)`
  font-size: 20px;
  fill: ${theme.colors.neutral.white};
`

export const WrapDrawerContent = styled.div`
  ${({ width }: { width: number }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 60px;
    width: ${width}px;
    max-width: 90vw;
    height: 100vh;
  `}
`

export const WrapDrawerNotifications = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  .row {
    width: 100%;
    font-size: ${theme.typography.sizes.xs};
    color: ${theme.colors.neutral.high};
    padding: ${theme.spacing.md} ${theme.spacing.xm};
    margin: auto ${theme.spacing.sm};
    align-items: center;
    gap: 35px;
    :nth-of-type(even) {
      background-color: ${theme.colors.neutral[100]};
      border-radius: ${theme.shapes.borderRadius.sm};
    }
    #date {
      font-weight: ${theme.typography.weight.lg};
    }
  }
  div {
    display: flex;
  }
`

export const EmptyNotificationsStyled = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${theme.spacing['2xm']};
  gap: 17px;
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.sm};
  line-height: ${theme.typography.sizes.xm};
  color: ${theme.colors.neutral.black};
  svg {
    margin-top: ${theme.spacing['2xl']};
  }
`

export const IconButtonCloseDrawerStyled = styled(IconButton)`
  padding: 0;
`

export const EmptySpaceDivider = styled('div')`
  ${({ isSubmenu }: { isSubmenu?: boolean }) => css`
    height: 30px;
    background-color: ${isSubmenu
      ? theme.colors.neutral[100]
      : theme.colors.neutral.white};
  `}
`

export const DividerStyled = styled('hr')`
  border-top: 1px solid ${theme.colors.neutral.lighthover};
  border-right: none;
  border-bottom: none;
  border-left: none;
  margin: 0;
`
export const SmallerDividerStyled = styled(DividerStyled)`
  margin: 0 ${theme.spacing.lg};
`

export const DrawerHeaderStyled = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.lg};
`

export const SideBarTitleStyled = styled('span')`
  font-size: ${theme.typography.sizes['2md']};
  font-weight: ${theme.typography.weight.lg};
  font-family: ${theme.typography.family.primary};
  letter-spacing: 0.5px;
  color: ${theme.colors.neutral.high};
  margin-left: 0;
`

export const CloseIconStyled = styled(CloseIcon)`
  font-size: ${theme.typography.sizes['2md']};
  fill: ${theme.colors.neutral.white};
`

export const ListItemStyled = styled('div')`
  ${({ active }: { active?: boolean }) => css`
    display: flex;
    align-items: center;
    justify-content: ${active ? 'flex-start' : 'space-between'};
    gap: ${theme.spacing.sm};
    color: ${theme.colors.neutral.high};
    font-size: ${theme.typography.sizes.sm};
    line-height: ${theme.typography.lineHeight.md};
    padding: ${theme.spacing.xm} ${theme.spacing.lg};
    ${active &&
    css`
      font-family: ${theme.typography.family.bold};
      background-color: ${theme.colors.neutral[100]};
    `}
  `}
`

export const Dropdown = styled('div')`
  position: relative;
  height: 40px;
  align-items: center;
  display: flex;
  :hover {
    a.submenu-label {
      font-weight: ${theme.typography.weight.sm};
    }
    cursor: pointer;
    .dropdown-content {
      display: flex;
    }
  }
`

export const DropdownContent = styled('div')`
  display: none;
  position: absolute;
  flex-direction: column;
  padding: 8px 0px;
  top: 40px;
  gap: 4px;
  width: max-content;
  background: white;
  box-shadow: 0px 1px 3px 0px rgba(51, 69, 96, 0.2);
  border-radius: ${theme.shapes.borderRadius.sm};
  z-index: 1;
  a,
  span {
    height: 32px;
    margin: 0;
    padding: 0 ${theme.spacing.md};
    font-size: ${theme.typography.sizes.xs};

    :hover {
      background-color: ${theme.colors.quartenary};
    }
  }
`

export const ProfileMenuWrapper = styled.div`
  margin-left: ${theme.spacing.md};
`

export const DrawerLogoutButton = styled.button`
  background: none;
  border: none;
  outline: none;
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${theme.spacing.xs};
  color: ${theme.colors.support.red};
  font-family: ${theme.typography.family.bold};
  font-size: ${theme.typography.sizes.xs};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
`

export const SupportLink = styled.a`
  cursor: pointer;
  color: ${theme.colors.neutral.high};
  font-family: ${theme.typography.family.bold};
  text-decoration: underline;
`
